export const businessMessages = {
  businessRegistered: 'Business registered successfully!',
  businessRegistrationFailed: 'Failed to register business.',
}

export const loginMessages = {
  loginSuccess: 'Login successful!',
  loginFailed: 'Login failed. Please check your credentials.',
}

export const coOwnerMessages = {
  deleteCoOwner: 'Co-owner delete successfully',
  addCoOwner: 'Co-owner created successfully!',
  editCoOwner: 'Co-owner updated successfully!',
}

export const accountMessages = {
  registerSuccess: 'Registration successful!',
  registerFailed: 'Registration failed. Please try again.',
}

export const employeeMessages = {
  deleteEmployee: 'Employee delete successfully',
  addEmployee: 'Employee created successfully!',
  editEmployee: 'Employee updated successfully!',
}

export const customerMessages = {
  deleteCustomer: 'Customer delete successfully',
  addCustomer: 'Customer created successfully!',
  editCustomer: 'Customer updated successfully!',
  createdLoanRequest: 'Deal request submitted successfully!'
}

export const businessDocument = {
  deleteDocument: 'Document deleted successfully',
  createdDocument: 'Documents saved successfully',
  failedUpload: 'Failed to save documents'
}

export const bankerMessages = {
  deleteBanker: 'Banker delete successfully',
  addBanker: 'Banker created successfully!',
  editBanker: 'Banker updated successfully!',
}

export const commonMessage = {
  unknownError : 'An unexpected error occurred.'
}